// extracted by mini-css-extract-plugin
export default {"caseStudyScopedVariables":"CaseStudy_caseStudyScopedVariables__erR-P","pageLayout":"CaseStudy_pageLayout__hSjYE"};